<script>
    import { Col, Label, Row } from "sveltestrap";
    import { MultipleValues } from "../../../utils/Constant/Constant";
    import RangeSlider from 'svelte-range-slider-pips';
</script>
<Row class="form-group">
    <Label class="col-md-2 sm-left-text">{MultipleValues}</Label>
    <Col md="10">
      <RangeSlider
        pips
        steps={2}
        pipstep={2}
        min={0}
        max={16}
        float
        values={[4, 8, 12]} />
    </Col>
  </Row>